var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrueFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 175C59.3774 175 25.8 141.423 25.8 100C25.8 58.5774 59.3774 25 100.8 25C142.223 25 175.8 58.5774 175.8 100C175.8 141.423 142.223 175 100.8 175Z",
    fill: "url(#paint0_linear_26801_4416)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8 71.8333C35.8 89.782 58.1167 104.333 85.6334 104.333C113.15 104.333 135.467 89.782 135.467 71.8333C135.467 53.8847 113.15 39.3333 85.6334 39.3333C77.4011 39.287 69.223 40.6673 61.462 43.4132L35.8 35L46.5662 51.6682C39.8322 57.2105 35.8 64.2132 35.8 71.8333Z",
    fill: "url(#paint1_linear_26801_4416)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.8 132.5C165.8 150.449 143.483 165 115.967 165C88.45 165 66.1333 150.449 66.1333 132.5C66.1333 114.551 88.45 100 115.967 100C124.199 99.9536 132.377 101.334 140.138 104.08L165.8 95.6667L155.034 112.335C161.768 117.877 165.8 124.88 165.8 132.5Z",
    fill: "url(#paint2_linear_26801_4416)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.948 51.9325C102.163 51.1328 100.876 51.1328 100.091 51.9325L79.3452 73.0896C78.5611 73.8893 77.2732 73.8893 76.4891 73.0896L71.7942 68.3017C71.0101 67.502 69.7222 67.5021 68.9381 68.3017L68.4969 68.7517C67.7342 69.5294 67.7342 70.7745 68.4969 71.5522L76.296 79.5058C76.726 79.9442 77.3091 80.1905 77.9172 80.1905C78.5252 80.1905 79.1083 79.9442 79.5383 79.5058L103.389 55.183C104.151 54.4053 104.151 53.1602 103.389 52.3825L102.948 51.9325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.138 124.571C131.528 124.18 131.528 123.547 131.138 123.157L129.488 121.507C129.098 121.117 128.464 121.117 128.074 121.507L118.02 131.561C117.629 131.952 116.996 131.952 116.606 131.561L106.552 121.507C106.161 121.117 105.528 121.117 105.138 121.507L103.488 123.157C103.098 123.547 103.098 124.18 103.488 124.571L113.542 134.625C113.933 135.015 113.933 135.648 113.542 136.039L103.488 146.093C103.098 146.483 103.098 147.117 103.488 147.507L105.138 149.157C105.528 149.547 106.161 149.547 106.552 149.157L116.606 139.103C116.996 138.712 117.629 138.712 118.02 139.103L128.074 149.157C128.464 149.547 129.098 149.547 129.488 149.157L131.138 147.507C131.528 147.117 131.528 146.483 131.138 146.093L121.084 136.039C120.693 135.648 120.693 135.015 121.084 134.625L131.138 124.571Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 117.333C112.766 117.333 122.467 107.633 122.467 95.6667C122.467 83.7005 112.766 74 100.8 74C88.8338 74 79.1333 83.7005 79.1333 95.6667C79.1333 107.633 88.8338 117.333 100.8 117.333Z",
    fill: "url(#paint3_linear_26801_4416)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 93.5C118.134 89.8954 117.234 86.3478 115.515 83.1796C113.796 80.0113 111.312 77.3229 108.29 75.3585C103.295 73.5098 97.7941 73.5674 92.8391 75.5202C87.8841 77.4729 83.8228 81.1839 81.4322 85.9431C79.0416 90.7024 78.4894 96.1759 79.8812 101.317C81.273 106.458 84.5111 110.905 88.9763 113.808C92.2494 115.027 95.7691 115.434 99.2341 114.995C102.699 114.557 106.006 113.285 108.872 111.288C111.738 109.292 114.078 106.631 115.691 103.533C117.303 100.435 118.142 96.9926 118.133 93.5Z",
    fill: "url(#paint4_linear_26801_4416)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0492 88.0165C98.6033 87.3887 99.4046 87 100.3 87C101.957 87 103.3 88.3432 103.3 90C103.3 91.3965 102.343 92.577 101.045 92.9076C99.3617 93.336 97.3001 94.8852 97.3001 97.5V99C97.3001 100.657 98.6432 102 100.3 102C101.957 102 103.3 100.657 103.3 99V98.487C106.794 97.2513 109.3 93.9216 109.3 90C109.3 85.0295 105.271 81 100.3 81C97.6115 81 95.1956 82.1826 93.5509 84.0461C92.4545 85.2883 92.5727 87.1841 93.8149 88.2805C95.057 89.3769 96.953 89.2587 98.0492 88.0165ZM100.3 105C98.6433 105 97.3002 106.343 97.3002 108C97.3002 109.657 98.6433 111 100.3 111H100.33C101.987 111 103.33 109.657 103.33 108C103.33 106.343 101.987 105 100.33 105H100.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_4416",
    x1: 25.8,
    y1: 36.7188,
    x2: 168.769,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_4416",
    x1: 85.6334,
    y1: 35,
    x2: 85.6334,
    y2: 104.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_4416",
    x1: 115.967,
    y1: 95.6667,
    x2: 115.967,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_4416",
    x1: 83.8729,
    y1: 74,
    x2: 133.984,
    y2: 105.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_4416",
    x1: 83.395,
    y1: 74.0126,
    x2: 129.822,
    y2: 101.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueFalse);
export default __webpack_public_path__ + "static/media/True-False.09056314fa834c3a3403778abbf95bae.svg";
export { ForwardRef as ReactComponent };